import angular from 'angular';
import { buyPackage } from '../../../../shared/services/servicePackages';

export const ServicePackagesService = [
  'httpApi',
  'logger',
  function (httpApi, logger) {
    this.buyPackage = parameters => {
      return buyPackage({ httpApi, logger, parameters }).then(({ code, message }) => ({ code, message }));
    };
  },
];

angular.module('cian.addForm').service('servicePackagesService', ServicePackagesService);
